export default __webpack_public_path__ + "assets/media/ab6499d4502ee8182a7c7df54621eb33.mp3";